"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.trimAgentDraft = exports.buildAgentPayload = exports.toAgentDraft = exports.normalizeAgentSettings = exports.normalizeTool = exports.getAgentName = exports.getAgentId = exports.normalizeList = exports.getResponseBody = exports.toSnakeCase = exports.mapRowsToParameters = exports.mapParametersToRows = exports.normalizeToolParameters = exports.RAG_APP_ID_REGEX = exports.PARAMETER_NAME_REGEX = exports.TOOL_NAME_REGEX = exports.DEFAULT_TOOL_PARAMETERS = exports.PARAMETER_TYPE_OPTIONS = exports.INITIAL_CODE = exports.AGENT_ROLE_OPTIONS = exports.toolBehaviorOptions = void 0;
exports.toolBehaviorOptions = [
    { id: 'handoff', name: 'Handoff to another agent' },
    { id: 'tool_call', name: 'Tool call' },
    { id: 'rag', name: 'RAG knowledge lookup' },
];
exports.AGENT_ROLE_OPTIONS = [
    { id: 'specialist', name: 'Task-specific Agent' },
    { id: 'orchestrator', name: 'Orchestrator Agent' },
    { id: 'faq', name: 'FAQ agent' },
];
exports.INITIAL_CODE = 'def run(**kwargs) -> dict:\n    return {"format": False, "response": "", "next_agent": ""}';
exports.PARAMETER_TYPE_OPTIONS = [
    { id: 'string', name: 'string' },
    { id: 'number', name: 'number' },
    { id: 'integer', name: 'integer' },
    { id: 'boolean', name: 'boolean' },
    { id: 'array', name: 'array' },
    { id: 'object', name: 'object' },
];
exports.DEFAULT_TOOL_PARAMETERS = {
    type: 'object',
    properties: {},
    required: [],
    additionalProperties: false,
};
exports.TOOL_NAME_REGEX = /^[A-Za-z0-9_]+$/;
exports.PARAMETER_NAME_REGEX = /^[A-Za-z0-9_]+$/;
exports.RAG_APP_ID_REGEX = /^[A-Za-z0-9_-]+$/;
exports.normalizeToolParameters = function (parameters) {
    var _a;
    if (!parameters || typeof parameters !== 'object') {
        return __assign({}, exports.DEFAULT_TOOL_PARAMETERS);
    }
    return {
        type: (_a = parameters === null || parameters === void 0 ? void 0 : parameters.type) !== null && _a !== void 0 ? _a : 'object',
        properties: (parameters === null || parameters === void 0 ? void 0 : parameters.properties) && typeof parameters.properties === 'object'
            ? parameters.properties
            : {},
        required: Array.isArray(parameters === null || parameters === void 0 ? void 0 : parameters.required) ? parameters.required : [],
        additionalProperties: typeof (parameters === null || parameters === void 0 ? void 0 : parameters.additionalProperties) === 'boolean'
            ? parameters.additionalProperties
            : false,
    };
};
exports.mapParametersToRows = function (parameters) {
    var normalized = exports.normalizeToolParameters(parameters);
    var requiredSet = new Set(normalized.required);
    var propertyNames = Object.keys(normalized.properties || {});
    return propertyNames.map(function (propertyName, index) {
        var _a, _b;
        var propertyData = normalized.properties[propertyName] || {};
        var enumValues = Array.isArray(propertyData["enum"])
            ? propertyData["enum"].join(', ')
            : '';
        return {
            rowId: "param-" + (propertyName || 'empty') + "-" + index,
            name: propertyName,
            type: (_a = propertyData.type) !== null && _a !== void 0 ? _a : 'string',
            description: (_b = propertyData.description) !== null && _b !== void 0 ? _b : '',
            enumValues: enumValues,
            required: requiredSet.has(propertyName),
        };
    });
};
exports.mapRowsToParameters = function (rows) {
    var properties = {};
    var required = [];
    rows.forEach(function (row) {
        var fieldName = ((row === null || row === void 0 ? void 0 : row.name) || '').trim();
        var propertySchema = {
            type: (row === null || row === void 0 ? void 0 : row.type) || 'string',
        };
        var description = ((row === null || row === void 0 ? void 0 : row.description) || '').trim();
        if (description) {
            propertySchema.description = description;
        }
        var enumList = ((row === null || row === void 0 ? void 0 : row.enumValues) || '')
            .split(',')
            .map(function (value) { return value.trim(); })
            .filter(Boolean);
        if (enumList.length) {
            propertySchema["enum"] = enumList;
        }
        properties[fieldName] = propertySchema;
        if (row === null || row === void 0 ? void 0 : row.required) {
            required.push(fieldName);
        }
    });
    return {
        type: 'object',
        properties: properties,
        required: required,
        additionalProperties: false,
    };
};
exports.toSnakeCase = function (value) {
    if (value === void 0) { value = ''; }
    return value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
};
exports.getResponseBody = function (response) { var _a, _b, _c; return (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : response) !== null && _c !== void 0 ? _c : {}; };
exports.normalizeList = function (data) {
    if (Array.isArray(data))
        return data;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.agents))
        return data.agents;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.results))
        return data.results;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.data))
        return data.data;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.models))
        return data.models;
    return [];
};
exports.getAgentId = function (agent) { var _a, _b; return (_b = (_a = agent === null || agent === void 0 ? void 0 : agent.id) !== null && _a !== void 0 ? _a : agent === null || agent === void 0 ? void 0 : agent['agent_id']) !== null && _b !== void 0 ? _b : agent === null || agent === void 0 ? void 0 : agent.agentId; };
exports.getAgentName = function (agent, index) {
    return (agent === null || agent === void 0 ? void 0 : agent.name) || (agent === null || agent === void 0 ? void 0 : agent.title) || (agent === null || agent === void 0 ? void 0 : agent['display_name']) ||
        "Agent " + (index + 1);
};
exports.normalizeTool = function (tool) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    if (tool.mode === 'tool_call') {
        return {
            id: (_a = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _a !== void 0 ? _a : null,
            mode: (_b = tool === null || tool === void 0 ? void 0 : tool.mode) !== null && _b !== void 0 ? _b : '',
            description: (_c = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _c !== void 0 ? _c : '',
            name: (_e = (_d = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _d !== void 0 ? _d : tool === null || tool === void 0 ? void 0 : tool['tool_name']) !== null && _e !== void 0 ? _e : '',
            parameters: exports.normalizeToolParameters(tool === null || tool === void 0 ? void 0 : tool.parameters),
            code: (_f = tool === null || tool === void 0 ? void 0 : tool.code) !== null && _f !== void 0 ? _f : exports.INITIAL_CODE,
        };
    }
    if ((tool === null || tool === void 0 ? void 0 : tool.mode) === 'handoff') {
        return {
            id: (_g = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _g !== void 0 ? _g : null,
            mode: (_h = tool === null || tool === void 0 ? void 0 : tool.mode) !== null && _h !== void 0 ? _h : '',
            description: (_j = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _j !== void 0 ? _j : '',
            nextAgent: (_k = tool === null || tool === void 0 ? void 0 : tool['target_agent']) !== null && _k !== void 0 ? _k : '',
            name: (_m = (_l = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _l !== void 0 ? _l : tool === null || tool === void 0 ? void 0 : tool['tool_name']) !== null && _m !== void 0 ? _m : '',
        };
    }
    if ((tool === null || tool === void 0 ? void 0 : tool.mode) === 'rag') {
        return {
            id: (_o = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _o !== void 0 ? _o : null,
            mode: (_p = tool === null || tool === void 0 ? void 0 : tool.mode) !== null && _p !== void 0 ? _p : '',
            description: (_q = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _q !== void 0 ? _q : '',
            name: (_s = (_r = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _r !== void 0 ? _r : tool === null || tool === void 0 ? void 0 : tool['tool_name']) !== null && _s !== void 0 ? _s : '',
            appId: (_u = (_t = tool === null || tool === void 0 ? void 0 : tool.appId) !== null && _t !== void 0 ? _t : tool === null || tool === void 0 ? void 0 : tool['app_id']) !== null && _u !== void 0 ? _u : '',
            prompt: (_v = tool === null || tool === void 0 ? void 0 : tool.prompt) !== null && _v !== void 0 ? _v : '',
            languageSpecificPrompt: (_x = (_w = tool === null || tool === void 0 ? void 0 : tool.languageSpecificPrompt) !== null && _w !== void 0 ? _w : tool === null || tool === void 0 ? void 0 : tool['language_specific_prompt']) !== null && _x !== void 0 ? _x : {},
        };
    }
    return {
        id: (_y = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _y !== void 0 ? _y : null,
        mode: (_z = tool === null || tool === void 0 ? void 0 : tool.mode) !== null && _z !== void 0 ? _z : '',
        description: (_0 = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _0 !== void 0 ? _0 : '',
        name: (_2 = (_1 = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _1 !== void 0 ? _1 : tool === null || tool === void 0 ? void 0 : tool['tool_name']) !== null && _2 !== void 0 ? _2 : '',
    };
};
exports.normalizeAgentSettings = function (agentSettings) {
    if (!agentSettings || typeof agentSettings !== 'object') {
        return {};
    }
    if (Array.isArray(agentSettings)) {
        return {};
    }
    return __assign({}, agentSettings);
};
exports.toAgentDraft = function (agent) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    var tools = [];
    var toolConfig = agent === null || agent === void 0 ? void 0 : agent['tool_config'];
    if (Array.isArray(agent === null || agent === void 0 ? void 0 : agent.tools)) {
        tools = agent.tools;
    }
    else if (Array.isArray(toolConfig)) {
        tools = toolConfig;
    }
    return {
        id: exports.getAgentId(agent),
        name: (_b = (_a = agent === null || agent === void 0 ? void 0 : agent.name) !== null && _a !== void 0 ? _a : agent === null || agent === void 0 ? void 0 : agent.title) !== null && _b !== void 0 ? _b : '',
        description: (_c = agent === null || agent === void 0 ? void 0 : agent.description) !== null && _c !== void 0 ? _c : '',
        modelProvider: (_j = (_h = (_f = (_e = (_d = agent === null || agent === void 0 ? void 0 : agent['llm_provider']) !== null && _d !== void 0 ? _d : agent === null || agent === void 0 ? void 0 : agent['model_provider']) !== null && _e !== void 0 ? _e : agent === null || agent === void 0 ? void 0 : agent.provider) !== null && _f !== void 0 ? _f : (_g = agent === null || agent === void 0 ? void 0 : agent.model) === null || _g === void 0 ? void 0 : _g.provider) !== null && _h !== void 0 ? _h : agent === null || agent === void 0 ? void 0 : agent['llm_provider']) !== null && _j !== void 0 ? _j : '',
        model: (_o = (_m = (_l = (_k = agent === null || agent === void 0 ? void 0 : agent['llm_model']) !== null && _k !== void 0 ? _k : agent === null || agent === void 0 ? void 0 : agent.model) !== null && _l !== void 0 ? _l : agent === null || agent === void 0 ? void 0 : agent['model_id']) !== null && _m !== void 0 ? _m : agent === null || agent === void 0 ? void 0 : agent['model_name']) !== null && _o !== void 0 ? _o : '',
        role: (_p = agent === null || agent === void 0 ? void 0 : agent.role) !== null && _p !== void 0 ? _p : 'specialist',
        languageSpecificInstructions: (_q = agent === null || agent === void 0 ? void 0 : agent['language_specific_instructions']) !== null && _q !== void 0 ? _q : {},
        deletedToolIds: Array.isArray(agent === null || agent === void 0 ? void 0 : agent['deleted_tool_ids'])
            ? agent === null || agent === void 0 ? void 0 : agent['deleted_tool_ids'] : [],
        isDefault: Boolean((_s = (_r = agent === null || agent === void 0 ? void 0 : agent['is_default']) !== null && _r !== void 0 ? _r : agent === null || agent === void 0 ? void 0 : agent['default_agent']) !== null && _s !== void 0 ? _s : false),
        enableDateTimeContext: Boolean((_v = (_u = (_t = agent === null || agent === void 0 ? void 0 : agent['date_time_context_enabled']) !== null && _t !== void 0 ? _t : agent === null || agent === void 0 ? void 0 : agent['enable_datetime_context']) !== null && _u !== void 0 ? _u : agent === null || agent === void 0 ? void 0 : agent['enable_datetime_context_for_agent']) !== null && _v !== void 0 ? _v : false),
        commonPrompt: (_x = (_w = agent === null || agent === void 0 ? void 0 : agent['common_prompt']) !== null && _w !== void 0 ? _w : agent === null || agent === void 0 ? void 0 : agent.prompt) !== null && _x !== void 0 ? _x : '',
        instructions: (_z = (_y = agent === null || agent === void 0 ? void 0 : agent.instructions) !== null && _y !== void 0 ? _y : agent === null || agent === void 0 ? void 0 : agent['text_instructions']) !== null && _z !== void 0 ? _z : '',
        commonGuardrails: (_1 = (_0 = agent === null || agent === void 0 ? void 0 : agent['common_guardrails']) !== null && _0 !== void 0 ? _0 : agent === null || agent === void 0 ? void 0 : agent.guardrails) !== null && _1 !== void 0 ? _1 : '',
        agentSettings: exports.normalizeAgentSettings((_2 = agent === null || agent === void 0 ? void 0 : agent['agent_settings']) !== null && _2 !== void 0 ? _2 : agent === null || agent === void 0 ? void 0 : agent.agentSettings),
        tools: tools.map(exports.normalizeTool),
        isNew: Boolean(agent === null || agent === void 0 ? void 0 : agent.isNew),
    };
};
exports.buildAgentPayload = function (agentDraft) {
    var _a, _b, _c, _d, _e, _f;
    var agentSettings = (agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.role) === 'faq'
        ? {}
        : exports.normalizeAgentSettings(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.agentSettings);
    var payload = {
        name: (_a = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.name) !== null && _a !== void 0 ? _a : '',
        llm_provider: (_b = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.modelProvider) !== null && _b !== void 0 ? _b : '',
        llm_model: (_c = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.model) !== null && _c !== void 0 ? _c : '',
        is_default: Boolean(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.isDefault),
        date_time_context_enabled: Boolean(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.enableDateTimeContext),
        instructions: (_d = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.instructions) !== null && _d !== void 0 ? _d : '',
        language_specific_instructions: (_e = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.languageSpecificInstructions) !== null && _e !== void 0 ? _e : {},
        role: (_f = agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.role) !== null && _f !== void 0 ? _f : 'specialist',
        deleted_tool_ids: Array.isArray(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.deletedToolIds)
            ? agentDraft.deletedToolIds
            : [],
        agent_settings: agentSettings,
        tools: Array.isArray(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.tools)
            ? agentDraft.tools.map(function (tool) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                var toolMode = (_a = tool === null || tool === void 0 ? void 0 : tool.mode) !== null && _a !== void 0 ? _a : '';
                var baseToolPayload = {
                    id: (_b = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _b !== void 0 ? _b : null,
                    mode: toolMode,
                    description: (_c = tool === null || tool === void 0 ? void 0 : tool.description) !== null && _c !== void 0 ? _c : '',
                    name: (_d = tool === null || tool === void 0 ? void 0 : tool.name) !== null && _d !== void 0 ? _d : '',
                };
                if (toolMode === 'handoff') {
                    baseToolPayload.target_agent = (_e = tool === null || tool === void 0 ? void 0 : tool.nextAgent) !== null && _e !== void 0 ? _e : null;
                }
                if (toolMode === 'tool_call') {
                    baseToolPayload.parameters = exports.normalizeToolParameters(tool === null || tool === void 0 ? void 0 : tool.parameters);
                    baseToolPayload.code = (_f = tool === null || tool === void 0 ? void 0 : tool.code) !== null && _f !== void 0 ? _f : exports.INITIAL_CODE;
                }
                if (toolMode === 'rag') {
                    baseToolPayload.app_id = (_g = tool === null || tool === void 0 ? void 0 : tool.appId) !== null && _g !== void 0 ? _g : '';
                    baseToolPayload.prompt = (_h = tool === null || tool === void 0 ? void 0 : tool.prompt) !== null && _h !== void 0 ? _h : '';
                    baseToolPayload.language_specific_prompt = (_j = tool === null || tool === void 0 ? void 0 : tool.languageSpecificPrompt) !== null && _j !== void 0 ? _j : {};
                }
                return baseToolPayload;
            })
            : [],
    };
    return payload;
};
exports.trimAgentDraft = function (agentDraft) {
    if (!agentDraft || typeof agentDraft !== 'object')
        return agentDraft;
    var trimmedLanguageSpecificInstructions = Object.entries((agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.languageSpecificInstructions) || {}).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return acc;
    }, {});
    var trimmedAgentSettings = Object.entries(exports.normalizeAgentSettings(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.agentSettings)).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return acc;
    }, {});
    var trimmedTools = Array.isArray(agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.tools)
        ? agentDraft.tools.map(function (tool) {
            var normalizedParameters = exports.normalizeToolParameters(tool === null || tool === void 0 ? void 0 : tool.parameters);
            var trimmedProperties = Object.entries((normalizedParameters === null || normalizedParameters === void 0 ? void 0 : normalizedParameters.properties) || {}).reduce(function (acc, _a) {
                var propertyName = _a[0], propertySchema = _a[1];
                var trimmedPropertyName = (propertyName || '').toString().trim();
                acc[trimmedPropertyName] = __assign(__assign({}, (propertySchema || {})), { type: propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.type, description: ((propertySchema === null || propertySchema === void 0 ? void 0 : propertySchema.description) || '').toString().trim() });
                return acc;
            }, {});
            var trimmedRequired = Array.isArray(normalizedParameters === null || normalizedParameters === void 0 ? void 0 : normalizedParameters.required)
                ? normalizedParameters.required
                    .map(function (item) { return (item || '').toString().trim(); })
                    .filter(Boolean)
                : [];
            return __assign(__assign({}, (tool || {})), { name: ((tool === null || tool === void 0 ? void 0 : tool.name) || '').toString().trim(), description: ((tool === null || tool === void 0 ? void 0 : tool.description) || '').toString().trim(), nextAgent: tool === null || tool === void 0 ? void 0 : tool.nextAgent, appId: ((tool === null || tool === void 0 ? void 0 : tool.appId) || '').toString().trim(), prompt: ((tool === null || tool === void 0 ? void 0 : tool.prompt) || '').toString().trim(), languageSpecificPrompt: Object.entries((tool === null || tool === void 0 ? void 0 : tool.languageSpecificPrompt) || {}).reduce(function (acc, _a) {
                    var languageCode = _a[0], promptValue = _a[1];
                    acc[languageCode] =
                        typeof promptValue === 'string'
                            ? promptValue.trim()
                            : promptValue;
                    return acc;
                }, {}), parameters: __assign(__assign({}, normalizedParameters), { properties: trimmedProperties, required: trimmedRequired }) });
        })
        : [];
    return __assign(__assign({}, agentDraft), { name: ((agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.name) || '').toString().trim(), modelProvider: agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.modelProvider, model: agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.model, instructions: ((agentDraft === null || agentDraft === void 0 ? void 0 : agentDraft.instructions) || '').toString().trim(), languageSpecificInstructions: trimmedLanguageSpecificInstructions, agentSettings: trimmedAgentSettings, tools: trimmedTools });
};
